import styled from "styled-components";
import { Flex } from "../../../styled/flex";
import { Inter_12_500, Inter_14_600 } from "../../../../styles/text";
import React from "react";
import Link from "../../../styled/link";
import CheckpointStatusBadge from "../../../checkpoint/checkpointStatusBadge";
import LatestList from "../latestList";
import { ReactComponent as ShieldCheckIcon } from "../../../icons/check.svg";

const ThemeText = styled.p`
  margin: 0;
  color: ${(p) => p.theme.theme500};
  ${Inter_14_600};
`;

const BlockNumber = styled(ThemeText)`
  margin-bottom: 4px;
`;

const Time = styled.span`
  color: ${(props) => props.theme.fontTertiary};
  ${Inter_12_500};
`;

const StatusLabel = styled.div`
  ${Inter_12_500};
  color: ${(props) => props.theme.fontPrimary};
  margin-bottom: 4px;
`;

const ChainLabel = styled.span`
  ${Inter_12_500};
  color: ${(props) => props.theme.fontTertiary};
  padding: 2px 6px;
  border-radius: 3px;
  background-color: ${(props) => props.theme.backgroundSecondary};
`;

function LatestCheckpointEvents({ checkpoints, loading }) {
  const listItems = checkpoints?.slice(0, 5)?.map((checkpoint) => {
    const timestamp = new Date(checkpoint.timestamp);
    const now = Date.now();
    const diff = now - timestamp.getTime();
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    let timeAgo;
    if (days > 0) {
      timeAgo = `${days}d ago`;
    } else if (hours > 0) {
      timeAgo = `${hours}h ago`;
    } else if (minutes > 0) {
      timeAgo = `${minutes}m ago`;
    } else {
      timeAgo = `${seconds}s ago`;
    }

    return {
      icon: <ShieldCheckIcon style={{ width: 20, height: 20 }} />,
      left: (
        <div>
          <Link to={`/blocks/${checkpoint.blockNumber}`}>
            <BlockNumber>
              Block #{checkpoint.blockNumber?.toLocaleString()}
            </BlockNumber>
          </Link>
          <Flex gap={8}>
            <Time>{timeAgo}</Time>
          </Flex>
        </div>
      ),
      right: (
        <>
          <StatusLabel>
            <CheckpointStatusBadge
              status={checkpoint.status}
              showLabel={true}
            />
          </StatusLabel>
          <Flex gap={8} style={{ fontSize: 12, marginTop: 4 }}>
            <ChainLabel>REGAChain → REGABCB</ChainLabel>
          </Flex>
        </>
      ),
    };
  });

  return (
    <LatestList
      items={listItems}
      loading={loading}
      noDataText="No checkpoint events"
    />
  );
}

export default LatestCheckpointEvents;
